/** Стабильные ключи значений RSD (хранятся в API как строки / bool). */

export const REGISTRATION_TYPE_KEYS = ['new_registration', 'registration_extension']

export const REGISTRATION_PROCEDURE_KEYS = ['national', 'eaeu_mrp', 'eaeu_dcp']

export const POST_REGISTRATION_MEASURE_TYPE_KEYS = [
  'additional_requirements',
  'conditional_registration',
  'accelerated_registration',
  'exceptional_registration',
]

export const APPLICABLE_KEYS = ['applicable', 'not_applicable']

export const YES_NO_KEYS = ['yes', 'no']

export const REGULATOR_INTERACTION_KEYS = ['letters', 'consultations']

/** Ключи field_comments (детализация по пунктам шаблона). */
export const RSD_COMMENT_KEYS = [
  'registration_type',
  'registration_procedure',
  'reference_state',
  'recognition_states',
  'world_registration_period',
  'ref_state_registration_period',
  'additional_requirements_status',
  'conditional_registration_status',
  'accelerated_registration_status',
  'exceptional_registration_status',
  'nosology_code',
  'conclusion',
  'regulator_interaction',
  'clinical_data',
  'gmp_notes',
  'gcp',
  'samples',
  'other_regulatory',
  'packaging_description',
  'sku_gtin',
  'mah',
  'manufacturing_sites',
  'global_trade_name',
  'local_trade_name',
  'trademark_protection',
  'global_team',
  'planned_indication_registration',
  'study_code_name',
  'global_icsr_ready_date',
  'global_fcsr_ready_date',
  'rpc_approval_status',
  'study_name_phase',
  'clinical_trial_permission_date',
  'icsr_ready_date',
  'local_fcsr_ready_date',
  'study_indications',
  'planned_registration_dates',
  'early_access_program',
  'localize_secondary_packaging',
  'localize_fdf_production',
  'inclusion_strategy',
  'patents_text',
  'circulation_preliminary_testing',
  'circulation_launch_strategy_text',
  'other_information',
]
